// ARAMIS tokens. Generated from packages/brand/tokens.json. Do not edit by hand.
export const tokens = {
  "$description": "ARAMIS design tokens. Single source for website, admin (CSS variables) and mobile (Dart). Edit here, then run `npm run brand:build`.",
  "color": {
    "light": {
      "canvas": "#FAFAFA",
      "surface": "#FFFFFF",
      "sunken": "#F0F0F1",
      "line": "#E7E7E9",
      "control": "#A3A3A9",
      "text": "#0E0E10",
      "muted": "#5E5E65",
      "subtle": "#6E6E75",
      "inverse": "#0E0E10",
      "onInverse": "#FFFFFF",
      "accent": "#2A36B8",
      "accentPressed": "#212C9C",
      "accentSoft": "#ECEEFB",
      "onAccent": "#F7F8FF",
      "danger": "#B8342A",
      "dangerSoft": "#F7E4E1",
      "success": "#1B6E46",
      "successSoft": "#DFF0E6",
      "warning": "#955000",
      "warningSoft": "#F8EBD9",
      "chart": "#3542C6",
      "scrim": "rgba(14,14,16,0.40)",
      "shadow": "rgba(14,14,20,0.08)",
      "stage": "#1C2890",
      "onStage": "#F4F4F2"
    },
    "dark": {
      "canvas": "#09090A",
      "surface": "#151517",
      "sunken": "#1D1D20",
      "line": "#29292D",
      "control": "#606068",
      "text": "#F5F5F7",
      "muted": "#A1A1A8",
      "subtle": "#8B8B93",
      "inverse": "#F5F5F7",
      "onInverse": "#09090A",
      "accent": "#9AA4FF",
      "accentPressed": "#B4BBFF",
      "accentSoft": "#1C1F3F",
      "onAccent": "#0F0F11",
      "danger": "#FF7A6E",
      "dangerSoft": "#3A1B18",
      "success": "#5BCB93",
      "successSoft": "#12301F",
      "warning": "#F2AE58",
      "warningSoft": "#35250F",
      "chart": "#7480F0",
      "scrim": "rgba(0,0,0,0.60)",
      "shadow": "rgba(0,0,0,0.50)",
      "stage": "#1C2890",
      "onStage": "#F4F4F2"
    },
    "brand": {
      "ink": "#121214",
      "ivory": "#F4F4F2",
      "lajvard": "#2A36B8"
    }
  },
  "font": {
    "fa": "IRANSans",
    "latin": "IRANSans",
    "weights": {
      "thin": 200,
      "light": 300,
      "regular": 400,
      "medium": 500,
      "bold": 700,
      "black": 900
    }
  },
  "type": {
    "displayXl": {
      "size": 56,
      "line": 72,
      "weight": 700
    },
    "displayL": {
      "size": 36,
      "line": 50,
      "weight": 700
    },
    "displayM": {
      "size": 26,
      "line": 38,
      "weight": 700
    },
    "titleL": {
      "size": 22,
      "line": 34,
      "weight": 500
    },
    "titleM": {
      "size": 18,
      "line": 28,
      "weight": 500
    },
    "titleS": {
      "size": 16,
      "line": 26,
      "weight": 500
    },
    "bodyL": {
      "size": 16,
      "line": 29,
      "weight": 400
    },
    "body": {
      "size": 15,
      "line": 26,
      "weight": 400
    },
    "bodyS": {
      "size": 13,
      "line": 22,
      "weight": 400
    },
    "label": {
      "size": 14,
      "line": 20,
      "weight": 500
    },
    "labelS": {
      "size": 12,
      "line": 16,
      "weight": 500
    },
    "price": {
      "size": 16,
      "line": 24,
      "weight": 500
    }
  },
  "space": {
    "0": 0,
    "1": 2,
    "2": 4,
    "3": 8,
    "4": 12,
    "5": 16,
    "6": 20,
    "7": 24,
    "8": 32,
    "9": 40,
    "10": 48,
    "11": 64,
    "12": 80,
    "13": 96,
    "14": 128
  },
  "radius": {
    "none": 0,
    "control": 2,
    "input": 14,
    "media": 16,
    "card": 20,
    "sheet": 28,
    "pill": 999
  },
  "motion": {
    "duration": {
      "instant": 0,
      "press": 120,
      "micro": 160,
      "small": 220,
      "medium": 320,
      "large": 460,
      "reveal": 620,
      "brand": 720,
      "count": 900,
      "breath": 120
    },
    "easing": {
      "out": [
        0.23,
        1,
        0.32,
        1
      ],
      "inOut": [
        0.77,
        0,
        0.175,
        1
      ],
      "drawer": [
        0.32,
        0.72,
        0,
        1
      ],
      "linear": [
        0,
        0,
        1,
        1
      ],
      "reveal": [
        0.16,
        1,
        0.3,
        1
      ]
    },
    "spring": {
      "settle": {
        "bounce": 0,
        "duration": 0.4
      },
      "flick": {
        "bounce": 0.18,
        "duration": 0.45
      }
    },
    "distance": {
      "enter": 12,
      "enterSmall": 8,
      "exit": 6
    },
    "scale": {
      "press": 0.97,
      "pressLarge": 0.985,
      "enterFrom": 0.96
    },
    "stagger": {
      "step": 60,
      "maxItems": 6
    },
    "blur": {
      "enter": 4
    }
  },
  "z": {
    "base": 0,
    "sticky": 20,
    "header": 30,
    "drawer": 40,
    "overlay": 50,
    "modal": 60,
    "toast": 70
  },
  "breakpoint": {
    "sm": 640,
    "md": 768,
    "lg": 1024,
    "xl": 1280,
    "xxl": 1536
  }
};
// The Arch: panel polygons on a 100x100 grid in drawing order. The "back" panel is the crossbar.
export const markPanels = [{"id":"left","back":false,"points":[[14,90],[14,46],[14.14,42.86],[14.55,39.75],[15.23,36.68],[16.17,33.69],[17.37,30.79],[18.82,28],[20.51,25.35],[22.42,22.86],[24.54,20.54],[26.86,18.42],[29.35,16.51],[32,14.82],[34.79,13.37],[37.69,12.17],[40.68,11.23],[43.75,10.55],[46.86,10.14],[48.5,10.07],[48.5,26.07],[48.26,26.08],[46.53,26.3],[44.82,26.68],[43.16,27.21],[41.55,27.87],[40,28.68],[38.53,29.62],[37.14,30.68],[35.86,31.86],[34.68,33.14],[33.62,34.53],[32.68,36],[31.87,37.55],[31.21,39.16],[30.68,40.82],[30.3,42.53],[30.08,44.26],[30,46],[30,90]]},{"id":"right","back":false,"points":[[70,90],[70,46],[69.92,44.26],[69.7,42.53],[69.32,40.82],[68.79,39.16],[68.13,37.55],[67.32,36],[66.38,34.53],[65.32,33.14],[64.14,31.86],[62.86,30.68],[61.47,29.62],[60,28.68],[58.45,27.87],[56.84,27.21],[55.18,26.68],[53.47,26.3],[51.74,26.08],[51.5,26.07],[51.5,10.07],[53.14,10.14],[56.25,10.55],[59.32,11.23],[62.31,12.17],[65.21,13.37],[68,14.82],[70.65,16.51],[73.14,18.42],[75.46,20.54],[77.58,22.86],[79.49,25.35],[81.18,28],[82.63,30.79],[83.83,33.69],[84.77,36.68],[85.45,39.75],[85.86,42.86],[86,46],[86,90]]},{"id":"bar","back":true,"points":[[33,58],[67,58],[67,70],[33,70]]}];
export const markBox = {"x":14,"y":10,"width":72,"height":80};
export const markStrokes = [{"from":[14,90],"to":[50,10]},{"from":[50,10],"to":[86,90]},{"from":[30,58],"to":[70,58]}];
